// extracted by mini-css-extract-plugin
export default {"divLogo2":"Login_divLogo2__qF2yw","divLogo11":"Login_divLogo11__hMES6"};